/** Typed store hooks. The only file allowed to import react-redux's untyped versions. */

import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store.js';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
